export const experience = [
  { id: 1, label: "Your Job Title Goes Here", value: "" },
  { id: 2, label: "Company Name | 2020 - 2022", value: "" },
  { id: 3, label: "Description", value: "" },
];
